import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";

import CheckIcon from "@mui/icons-material/Check";
import CreateIcon from "@mui/icons-material/Create";

import { useSnackBar } from "../contexts/SnackBarContext";
import { useDispatch } from "../contexts/ToDoContext";

export default function ToDo({ todo, openUpdateDialog, openDeleteDialog }) {
  const dispatch = useDispatch();
  const { showHideSnackBar } = useSnackBar();

  function handleCheckButton() {
    dispatch({ type: "checked", payload: todo });
    showHideSnackBar("نم التعديل بنجاح");
  }

  function handleUpdateDialogOpen() {
    openUpdateDialog(todo);
  }

  function handleDeleteDialogOpen() {
    openDeleteDialog(todo);
  }

  return (
    <>
      <Card
        className="toDoCard"
        sx={{ minWidth: 275, background: "rgb(37 46 134)", marginTop: "30px" }}
      >
        <CardContent>
          <Grid container spacing={2}>
            <Grid size={8}>
              <Typography
                variant="h4"
                sx={{
                  color: "white",
                  float: "right",
                  fontSize: "28px",
                  marginBottom: "10px",
                  textDecoration: todo.isComplete ? "line-through" : "none",
                }}
              >
                {todo.title}
              </Typography>
              <br />
              <Typography
                variant="h6"
                sx={{
                  color: "white",
                  float: "right",
                  fontSize: "18px",
                }}
              >
                {todo.description}
              </Typography>
            </Grid>
            <Grid
              size={4}
              style={{
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center",
              }}
            >
              <IconButton
                className="iconButton"
                onClick={handleCheckButton}
                style={{
                  background: todo.isComplete ? "#8bc34a" : "white",
                  color: todo.isComplete ? "white" : "#8bc34a",
                  border: "3px solid #8bc34a",
                }}
              >
                <CheckIcon />
              </IconButton>
              <IconButton
                onClick={handleUpdateDialogOpen}
                className="iconButton"
                style={{
                  background: "white",
                  color: "#1769aa",
                  border: "3px solid #1769aa",
                }}
              >
                <CreateIcon />
              </IconButton>
              <IconButton
                onClick={handleDeleteDialogOpen}
                className="iconButton"
                style={{
                  background: "white",
                  color: "#b23c17",
                  border: "3px solid #b23c17",
                }}
              >
                <DeleteIcon />
              </IconButton>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </>
  );
}
